import * as angular from 'angular';
import {IController} from "angular";

export class servicePricingCtrl implements IController {
  service: any;
  billing: any;

}

angular
  .module('bringoz.admin.deliveries')
  .component('servicePricing', {
    bindings: {
      service: '<',
      billing: '<'
    },
    template: require('./service-pricing.html').default,
    controller: servicePricingCtrl
  });
